import React from 'react'
import SinglePageRenderer from '../SinglePageRenderer'

const SignupPage = () => (
	<SinglePageRenderer paddingTop={70} title="SN - Contact" pageId="contact" />
)

export default SignupPage
